module.exports = __webpack_public_path__ + "img/SKMJ_light3.56739435.jpg";